import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Divider.st.css.js';
import { DIRECTIONS, SKINS } from './Divider.constants';
const Divider = ({ dataHook, className, direction = DIRECTIONS.horizontal, skin = SKINS.light, }) => (React.createElement("hr", { "data-hook": dataHook, className: st(classes.root, { direction, skin }, className) }));
Divider.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    direction: PropTypes.oneOf(Object.values(DIRECTIONS)),
    skin: PropTypes.oneOf(Object.values(SKINS)),
};
export default Divider;
//# sourceMappingURL=Divider.js.map